import type { AppStatusIssue } from "./appStatusTypes";

export interface AppIssuePalette {
  accent: string;
  border: string;
  background: string | undefined;
  chipText: string;
  chipBorder: string;
  chipBackground: string;
}

const CYAN = "#83cee0";
const ADMIN_SEVERITY = {
  error: { accent: "#ff5b62", border: "rgba(255,91,98,.34)", chipText: "#ff8b90", chipBorder: "rgba(255,91,98,.52)", chipBackground: "rgba(255,91,98,.10)" },
  warning: { accent: "#f4a340", border: "rgba(244,163,64,.34)", chipText: "#ffc36f", chipBorder: "rgba(244,163,64,.52)", chipBackground: "rgba(244,163,64,.10)" },
  info: { accent: CYAN, border: "rgba(131,206,224,.22)", chipText: "#9ce9fa", chipBorder: "rgba(131,206,224,.42)", chipBackground: "rgba(131,206,224,.09)" },
} as const;

/**
 * Farbvertrag für Meldungen ab v0.204.0:
 * - reine Admin-Meldungen verwenden die bisherige normale Severity-Farbe;
 * - Meldungen für alle Benutzer verwenden die bisherige kräftige Admin-Cyan-Farbe.
 * Semantik, Zielgruppe und Quittierungslogik bleiben unverändert.
 */
export function appIssuePalette(issue: Pick<AppStatusIssue, "adminOnly" | "severity">): AppIssuePalette {
  if (issue.adminOnly) {
    const tone = ADMIN_SEVERITY[issue.severity];
    return { ...tone, background: undefined };
  }
  return {
    accent: CYAN,
    border: "rgba(131,206,224,.52)",
    background: "rgba(18,31,35,.98)",
    chipText: "#9ce9fa",
    chipBorder: "rgba(131,206,224,.62)",
    chipBackground: "rgba(131,206,224,.13)",
  };
}
